import ICashierProxy from "./cashier_proxy_service_interface";
import BaseService from "../../base/base_service";
import {
    ICashierService,
    OpenCashierOptions,
    OpenDepositOptions,
    OpenWithdrawOptions,
    OpenTransactionHistoryOptions
} from "../../../../common/interfaces/cashier.service.interface";

interface CashierProxyServiceParams {
    getCashierService: () => ICashierService;
}
export default class CashierProxyService extends BaseService implements ICashierProxy {
    static CLASS = 'CashierProxyService';
    private _params: CashierProxyServiceParams;

    init(params: CashierProxyServiceParams) {
        this._params = params;
    }

    isEligibleForDepositWidget(): Promise<boolean> {
        return this._params.getCashierService().isEligibleForDepositWidget();
    }

    isCashierInRedirectMode(): Promise<boolean> {
        return this._params.getCashierService().isCashierInRedirectMode();
    }

    getProductPackage() {
        return this._params.getCashierService().getProductPackage();
    }

    openDeposit(options: OpenDepositOptions): Promise<void> {
        return this._params.getCashierService().openDeposit(options);
    }
    
    openWithdraw(options: OpenWithdrawOptions): Promise<void> {
        return this._params.getCashierService().openWithdraw(options);
    }

    openTransactionHistory(options: OpenTransactionHistoryOptions): Promise<void> {
        return this._params.getCashierService().openTransactionHistory(options);
    }

    openCashier(options?: OpenCashierOptions): Promise<void> {
        return this._params.getCashierService().openCashier(options);
    }
    openVerifyId(): Promise<void> {
        return this._params.getCashierService().openVerifyId();
    }

    openOldCashier(options?: OpenCashierOptions): Promise<void> {
        return this._params.getCashierService().openOldCashier(options);
    }

}